<template>
    <div class="p-campaign2025 | l-inner">
        <app-section
            :title="pageHeading"
            :desc="page.desc"
            :push="page.push"
            bgIntro="lighter"
            :image="page.image_hero"
            intro-position="bottom"
            :page="page"
            :image-has-background="true"
            :hide-hero-overlay="page.hide_hero_overlay === true"
        >
            <template #content>
                <slice-zone :slices="page.body" />
            </template>
        </app-section>
        <about />
    </div>
</template>

<script>
import { mapState } from "vuex";

import About from "layout/About";
import AnimText from "objects/AnimText";
import AppSection from "layout/AppSection";
import EntrepreneurQuote from "components/EntrepreneurQuote/EntrepreneurQuote";
// import EntrepreneurThumbnail from "components/EntrepreneurThumbnail/EntrepreneurThumbnail";
// import EntrepreneurTitleText from "components/EntrepreneurTitleText/EntrepreneurTitleText";
// import EntrepreneurVerticalName from "components/EntrepreneurVerticalName/EntrepreneurVerticalName";
// import EntrepreneurVideo from "components/EntrepreneurVideo/EntrepreneurVideo";
import Icon from "objects/Icon";
import SliceZone from "components/SliceZone/SliceZone";

export default {
    name: "Campaign2025",
    components: {
        About,
        AnimText,
        AppSection,
        EntrepreneurQuote,
        // EntrepreneurThumbnail,
        // EntrepreneurTitleText,
        // EntrepreneurVerticalName,
        // EntrepreneurVideo,
        Icon,
        SliceZone,
    },
    props: {
        page: Object
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            currentPage: state => state.global.currentPage
        }),
        pageHeading() {
            return this.page.heading[0].text || this.page.title;
        }
    },
    methods: {
        ////////////////////////////////
        //       START FIND A DATA BY SLICE TYPE
        ////////////////////////////////
        findCard(sliceType, data) {
            return data.find(x => x.slice_type === sliceType);
        }
        ////////////////////////////////
        //       END FIND A DATA BY SLICE TYPE
        ////////////////////////////////
    }
};
</script>
